import React from 'react';
import { observer } from 'mobx-react';
import { Box, LinearProgress, Typography } from '@mui/material';

function CompletionProgressBar({ form, title, showPercentage = true }) {
    const percentage = form.mandatoryCompletionPercentage();
    
    return (
        <Box mt={3}>
            {title && (
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="body2" color="textSecondary">
                        {title}
                    </Typography>
                    {showPercentage && (
                        <Typography variant="body2" color="textSecondary">
                            {percentage}%
                        </Typography>
                    )}
                </Box>
            )}
            {!title && showPercentage && (
                <Box display="flex" justifyContent="flex-end" mb={1}>
                    <Typography variant="body2" color="textSecondary">
                        {percentage}%
                    </Typography>
                </Box>
            )}
            <LinearProgress 
                variant="determinate" 
                value={percentage} 
                sx={(theme) => ({
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: theme.palette.action.hover,
                    '& .MuiLinearProgress-bar': {
                        borderRadius: 4,
                        backgroundColor: percentage === 100 ? theme.palette.success.main : theme.palette.primary.main
                    }
                })}
            />
        </Box>
    );
}

export default observer(CompletionProgressBar);
